import { Anagraphic } from '../models/user.model';

export const defaultAnagraphicForm: Anagraphic = {
  id: null,
  firstname: null,
  lastname: null,
  birthDate: null,
  birthPlace: null,
  email: null,
  fiscalCode: null,
  note: null,
  sex: null,
  phoneNumber: null,
};
